<div class="enroll-fix-errors-container">
    <div *ngIf="loading" class="loading">
        <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
    </div>
    <div class="stepper-wrappper">
        <app-stepper [is_processing]="is_processing"></app-stepper>
    </div>
</div>

<!-- <div *ngIf="columns_errors?.length" class="column-errors-wrapper">
    <app-column-errors></app-column-errors>
</div> -->

<div *ngIf="get_failed_records_retrieved"
    class="validation-errors-wrapper">
    <app-validation-errors [validationErrors]="validation_errors" [lang]="currLang" [batch_id]="current_upload_batch_id"></app-validation-errors>
</div>